import { render, staticRenderFns } from "./AudioRecord.vue?vue&type=template&id=4f803320&"
import script from "./AudioRecord.vue?vue&type=script&lang=js&"
export * from "./AudioRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports